import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';

const VidalyticsVideo = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const DIV_ID = 'vidalytics_embed_kQATcXc8b_erA0oP';
    const SCRIPT_ID = 'vidalytics_embed_kQATcXc8b_erA0oP';

    // Ensure the target div exists inside our Box
    if (!document.getElementById(DIV_ID) && containerRef.current) {
      const div = document.createElement('div');
      div.id = DIV_ID;
      div.style.width = '100%';
      div.style.position = 'relative';
      div.style.paddingTop = '56.25%'; // 16:9
      containerRef.current.appendChild(div);
    }

    // Avoid injecting the script twice
    if (document.getElementById(SCRIPT_ID)) {
      console.log('Vidalytics script already exists');
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = SCRIPT_ID;
    script.async = true;

    // This is your Vidalytics embed snippet wrapped as inline JS
    script.innerHTML = `(function (v, i, d, a, l, y, t, c, s) {
    y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
    if (!vsl){vsl=function(u,cb){
        if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
        if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
        i.getElementsByTagName("head")[0].appendChild(s);
    };}
    vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
})(window, document, 'Vidalytics', 'vidalytics_embed_kQATcXc8b_erA0oP', 'https://quick.vidalytics.com/embeds/_G4xahKS/kQATcXc8b_erA0oP/');`;
    console.log('About to append vidalytics script');
    document.head.appendChild(script);
    console.log('Appended vidalytics script');

    return () => {};
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: 850 },
        mx: 'auto',
        position: 'relative',
        aspectRatio: '16 / 9',
        '& .wistia_embed, & iframe, & video': {
          position: 'absolute',
          inset: 0,
          width: '100% !important',
          height: '100% !important',
        },
      }}
    />
  );
};

export default VidalyticsVideo;
